import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

export default function Analytics() {
  const location = useLocation()

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-ZXEJDRFPCL', {
        page_path: location.pathname,
      })
    }
  }, [location])

  useEffect(() => {
    const isMouseTrackingEnabled =
      process.env.REACT_APP_ENABLE_MOUSE_TRACKING === 'true'
    function trackMousePosition(event) {
      const { clientX, clientY } = event
      window.gtag('event', 'mousemove', {
        event_category: 'Mouse',
        event_label: `X: ${clientX}, Y: ${clientY}`,
      })
    }
    if (isMouseTrackingEnabled) {
      document.addEventListener('mousemove', trackMousePosition)
    }

    return () => {
      if (isMouseTrackingEnabled) {
        document.removeEventListener('mousemove', trackMousePosition)
      }
    }
  }, [])

  return (
    <Helmet>
      <script
        src="https://www.googletagmanager.com/gtag/js?id=G-ZXEJDRFPCL"
        async
      />
      <script>
        {`
          if (!window.dataLayer) {
            window.dataLayer = [];
          }
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-ZXEJDRFPCL');
        `}
      </script>
    </Helmet>
  )
}
